module.exports = __webpack_public_path__ + "0fc5952b2ad99db0fa1a49c2e0fd5928.woff";


//////////////////
// WEBPACK FOOTER
// ./src/assets/fonts/Material-Design-Icons.woff?-g7cqhn
// module id = 1548
// module chunks = 0